export default "__VITE_ASSET__DHIA5e9W__"